// Mixin for edit forms
//
let editFormMixin = function(options = {}) {
  options = Object.assign(
    {
      methodSuffix: "",
      dataProp: "internalValue",
      idFields: [],
      ignoredFields: [],
      legacyIDFields: []
    },
    options
  );

  let persistTimeout = null;
  let lastPersist = null;
  let currentlyPersisted = null;

  let mixin = {
    beforeDestroy() {
      this[`save${options.methodSuffix}`]().then(() => {
        window.removeEventListener(
          "beforeunload",
          this[`canNavigate${options.methodSuffix}`]
        );
      });
    },
    beforeMount() {
      window.addEventListener(
        "beforeunload",
        this[`canNavigate${options.methodSuffix}`]
      );
    },
    methods: {
      async [`save${options.methodSuffix}`](immediate = true, args = []) {
        if (currentlyPersisted === null) {
          this[`updateCurrent${options.methodSuffix}`](this[options.dataProp]);
          return;
        }

        if (this[`inputUnchanged${options.methodSuffix}`]() && !immediate) {
          return;
        }

        clearTimeout(persistTimeout);
        if (this.$apollo && this.$apollo.loading) {
          while (this.$apollo && this.$apollo.loading) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          persistTimeout = setTimeout(async () => {
            this[`save${options.methodSuffix}`](immediate, args);
          }, 1500);
        } else if (immediate === true) {
          while (this.$apollo && this.$apollo.loading) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          lastPersist = new Date();
          this[`persist${options.methodSuffix}`](...args);
        } else {
          while (this.$apollo && this.$apollo.loading) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          persistTimeout = setTimeout(
            async () => {
              lastPersist = new Date();
              this[`persist${options.methodSuffix}`](...args);
            },
            Number.isInteger(immediate) ? immediate : 1500
          );
        }
      },
      [`inputUnchanged${options.methodSuffix}`](data = null) {
        if (data === null) {
          data = this[options.dataProp];
        }

        let dataInput = this[`getInput${options.methodSuffix}`](data);

        return JSON.stringify(dataInput) === JSON.stringify(currentlyPersisted);
      },
      [`getInput${options.methodSuffix}`](val = null) {
        if (!val && !this[options.dataProp]) {
          return null;
        }

        return Object.prepareGqlInput(
          val || this[options.dataProp],
          options.idFields,
          options.ignoredFields,
          options.legacyIDFields
        );
      },
      [`updateCurrent${options.methodSuffix}`](input = null) {
        currentlyPersisted = this[`getInput${options.methodSuffix}`](input);
      },
      // Call if data is persisted successfully
      [`reportSuccess${options.methodSuffix}`](input) {
        currentlyPersisted = this[`getInput${options.methodSuffix}`](input);

        this.$emit("saved", lastPersist);
      },
      // Call if error occurred while persisting
      [`reportUnhandledError${options.methodSuffix}`](err) {
        this.$vs.notify({
          title: "Fehler",
          text:
            "Es ist ein Fehler beim Speichervorgang aufgetreten. <span style='font-weight:700;cursor:pointer;text-decoration:underline;'>Klicken für mehr Infos.</span>",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center",
          time: 10000,
          click: () => {
            let text = JSON.stringify(err);
            if (err.networkError) {
              if (err.graphQLErrors && err.graphQLErrors.length > 0) {
                // TODO
              } else if (
                err.networkError.result &&
                err.networkError.result.errors
              ) {
                text = "";
                for (let entry of err.networkError.result.errors) {
                  text += entry.message + "\n";
                }
              }
            }

            this.$vs.dialog({
              color: "danger",
              title: `Fehlermeldungen`,
              text,
              acceptText: "Melden",
              cancelText: "Abbrechen",
              accept: () => {
                let errorText = `URL: ${window.location.href}

                ERROR Info:
                ${JSON.stringify(err)}`;

                let href =
                  "mailto:support@kesslerdigital.de?subject=Promatch Formular Fehlermeldung&body=";
                href += encodeURIComponent(errorText);
                window.open(href, "_blank");
              },
              cancel: () => {}
            });
          }
        });
      },
      [`canNavigate${options.methodSuffix}`](e) {
        if (!this[`inputUnchanged${options.methodSuffix}`]()) {
          e.preventDefault();
          e.returnValue = "";
        }
      }
    }
  };

  return mixin;
};

export default editFormMixin;
